export const logoninformation = {
  headerTitle: 'Benutzerverwaltung',
  route: 'logoninformation',
  pageTitle: 'Benutzerverwaltung',
  related: [
    { route: 'benutzerverwaltung/lehrerinnen', menuTitle: 'Lehrer*innen verwalten' },
    { route: 'benutzerverwaltung/schuelerinnen', menuTitle: 'Schüler*innen verwalten' }
  ],
  cards: [
    {
      route: 'lehrerinnen',
      icon: 'lehrer-plus',
      endpoint: '/api/logoninformation/teachers',
      endpoints: {
        password: '/api/teachers/password',
        delete: '/api/teachers',
      },
      preHooks: {
        list: 'logoninformation_list_preHook'
      },
      tag: 'paedml-card-logoninformation',
      category: 'Benutzerverwaltung',
      menuTitle: 'Zusatzinfo Lehrer*innen',
      pageTitle: 'paed.ML - Zusatzinfo Lehrer*innen',
      name: 'logoninformationlul',
      contentTitle: 'Zusatzinfo Lehrer*innen',
      prefix: 'logoninformationlul',
      suffix: undefined,
      custom: {
        variant: 'teacher',
        deactivatedcol: 5,
        indexschulart: 3
      },
      table: {
        columns: [
          { title: 'ID', name: 'id', col: 0, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Benutzername', name: 'userName', col: 1 },
          { title: 'Name', name: 'displayName', col: 2 },
          { title: 'Basis-Schule', name: 'mainSchoolType', col: 3 },
          { title: 'Schule(n)', name: 'schoolTypes', separator: ', ', col: 4, filter: 'Schule', filterType: 'regex' },
          { title: 'Ist deaktiviert', name: "isDeactivated", col: 5, searchable: false },
          { title: 'Letzte Anmeldung', name: 'lastLogonUF', col: 6, searchable: false },
          { title: 'Letzte fehlgeschlagene Anmeldung', name: 'lastBadPasswordAttemptUF', col: 7, searchable: false },
          { title: 'Fehlgeschlagene Anmeldungen', name: 'badLogonCount', col: 8, searchable: false },
          { title: 'Letzte Kennwortänderung', name: 'lastPasswordSetUF', col: 9, searchable: false },
          { title: 'Letzte Externe ID Verifizierung', name: 'lastVerifiedDateUF', col: 10, searchable: false },
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10,
        }
      }
    },

    {
      route: 'schuelerinnen',
      icon: 'schueler-plus',
      endpoint: '/api/logoninformation/students',
      endpoints: {
        password: '/api/students/password',
        delete: '/api/students',
      },
      preHooks: {
        list: 'logoninformation_list_preHook'
      },
      tag: 'paedml-card-logoninformation',
      category: 'Benutzerverwaltung',
      menuTitle: 'Zusatzinfo Schüler*innen',
      pageTitle: 'paed.ML - Zusatzinfo Schüler*innen',
      name: 'logoninformationsus',
      contentTitle: 'Zusatzinfo Schüler*innen',
      prefix: 'logoninformationsus',
      suffix: undefined,
      custom: {
        variant: 'student',
        deactivatedcol: 6,
        indexschulart: 3
      },
      table: {
        columns: [
          { title: 'ID', name: 'id', col: 0, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Benutzername', name: 'userName', col: 1 },
          { title: 'Name', name: 'displayName', col: 2 },
          { title: 'Schule', name: 'schoolType', col: 3, filter: 'Schule', filterType: 'regex' },
          { title: 'Klasse', name: 'schoolClass', col: 4, filter: 'Klasse', dynamicfilter: 'klassen', filterType: 'regex' },
          { title: 'Schuljahr', name: 'schoolYear', col: 5, searchable: false },
          { title: 'Ist deaktiviert', name: "isDeactivated", col: 6, searchable: false },
          { title: 'Letzte Anmeldung', name: 'lastLogonUF', col: 7, searchable: false },
          { title: 'Letzte fehlgeschlagene Anmeldung', name: 'lastBadPasswordAttemptUF', col: 8, searchable: false },
          { title: 'Fehlgeschlagene Anmeldungen', name: 'badLogonCount', col: 9, searchable: false },
          { title: 'Letzte Kennwortänderung', name: 'lastPasswordSetUF', col: 10, searchable: false },
          { title: 'Letzte Externe ID Verifizierung', name: 'lastVerifiedDateUF', col: 11, searchable: false },
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10,
        }
      }
    },

    {
      route: 'klassenarbeiten',
      icon: 'klasse-plus',
      endpoint: '/api/logoninformation/exammembers',
      preHooks: {
        list: 'logoninformation_list_preHook'
      },
      tag: 'paedml-card-logoninformation',
      category: 'Benutzerverwaltung',
      menuTitle: 'Zusatzinfo Klassenarbeiten',
      pageTitle: 'paed.ML - Zusatzinfo KA-Teilnehmer',
      name: 'logoninformationexam',
      contentTitle: 'Zusatzinfo KA-Teilnehmer',
      prefix: 'logoninformationexam',
      suffix: undefined,
      custom: {
        variant: 'exammember'
      },
      table: {
        columns: [
          { title: 'Benutzername', name: 'userName', col: 0 },
          { title: 'Name', name: 'displayName', col: 1 },
          { title: 'Schule', name: 'schoolType', col: 2, filter: 'Schule', filterType: 'regex' },
          { title: 'Klasse', name: 'schoolClass', col: 3, filter: 'Klasse', dynamicfilter: 'klassen', filterType: 'regex' },
          { title: 'Schuljahr', name: 'schoolYear', col: 4, searchable: false },
          { title: 'Klassenarbeit', name: 'examTitle', col: 5 },
          { title: 'Letzte Anmeldung', name: 'lastLogonUF', col: 6, searchable: false },
          { title: 'Letzte fehlgeschlagene Anmeldung', name: 'lastBadPasswordAttemptUF', col: 7, searchable: false },
          { title: 'Fehlgeschlagene Anmeldungen', name: 'badLogonCount', col: 8, searchable: false },
          { title: 'Letzte Kennwortänderung', name: 'lastPasswordSetUF', col: 9, searchable: false },
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10,
        }
      }
    },
  ]
}
